export default __webpack_public_path__ + "static/media/customer05.6790ccca.jpg";